import React, { useState, useEffect } from 'react';
import { IonContent, IonPage, IonButton, IonText } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import logo from "../assets/logo.png";

const HomePage: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [isRussian, setIsRussian] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsRussian(prev => !prev);
    }, 5000); // Toggle every 5 seconds

    return () => clearInterval(interval);
  }, []);

  const welcomeText = isRussian ? "Добро пожаловать в" : t('home.welcome');
  const descriptionText = isRussian ? "Изучайте русский язык с персонализированными носителями языка" : t('home.description');

  return (
    <IonPage>
      <IonContent className="ion-padding">
        <div className="flex flex-col items-center pt-12">
          <img src={logo} alt="LangueWise Logo" className="h-72 w-72 rounded-[20px]" />
          <IonText>
            <h1 className="text-3xl text-center mt-12 font-bold mb-2">
              <span className="transition-opacity duration-1000" style={{ opacity: isRussian ? 0 : 1, position: 'absolute' }}>
                {t('home.welcome')}
              </span>
              <span className="transition-opacity duration-1000" style={{ opacity: isRussian ? 1 : 0 }}>
                {welcomeText}
              </span>
              {' '}
            </h1>
              <h1 className="text-3xl text-center font-bold text-[#31D526]">LangueWise</h1>
            <p className="text-2xl mt-8 text-center">
              <span className="transition-opacity duration-1000 left-0" style={{ opacity: isRussian ? 0 : 1, position: 'absolute' }}>
                {t('home.description')}
              </span>
              <span className="transition-opacity duration-1000" style={{ opacity: isRussian ? 1 : 0 }}>
                {descriptionText}
              </span>
            </p>
          </IonText>
          <div className="mt-20 flex gap-1">
            <IonButton className='text-xl' expand="block" onClick={() => history.push('/login')}>{t('home.login')}</IonButton>
            <IonButton className='text-xl' expand="block" onClick={() => history.push('/register')}>{t('home.register')}</IonButton>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default HomePage;
